module.exports = __webpack_public_path__ + "img/lmdc-logo-login.ec5d31e2.png";